
interface StatsOverviewProps {
  petitionCount: number;
  signerCount: number;
  commentCount: number;
  newsCount: number;
  orgCount: number;
}

export default function StatsOverview({
  petitionCount,
  signerCount,
  commentCount,
  newsCount,
  orgCount,
}: StatsOverviewProps) {
  const stats = [
    {
      label: '국회 청원 동의',
      value: petitionCount.toLocaleString(),
      suffix: '명',
      icon: 'ri-government-line',
      color: 'text-amber-600',
      bg: 'bg-amber-50',
    },
    {
      label: '사이트 서명',
      value: signerCount.toLocaleString(),
      suffix: '명',
      icon: 'ri-edit-line',
      color: 'text-red-600',
      bg: 'bg-red-50',
    },
    {
      label: '응원 메시지',
      value: commentCount.toLocaleString(),
      suffix: '건',
      icon: 'ri-chat-heart-line',
      color: 'text-rose-500',
      bg: 'bg-rose-50',
    },
    {
      label: '뉴스 기사',
      value: newsCount.toLocaleString(),
      suffix: '건',
      icon: 'ri-newspaper-line',
      color: 'text-teal-600',
      bg: 'bg-teal-50',
    },
    {
      label: '참여 단체',
      value: orgCount.toLocaleString(),
      suffix: '개',
      icon: 'ri-team-line',
      color: 'text-indigo-500',
      bg: 'bg-indigo-50',
    },
  ];

  return (
    <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-5">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-gray-50">
          <i className="ri-bar-chart-box-line text-lg text-gray-600"></i>
        </div>
        <h2 className="text-sm font-bold text-gray-900">전체 현황</h2>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
        {stats.map((stat) => (
          <div key={stat.label} className="bg-gray-50/70 rounded-xl p-3.5 text-center">
            <div className={`w-9 h-9 flex items-center justify-center rounded-lg ${stat.bg} mx-auto mb-2`}>
              <i className={`${stat.icon} text-lg ${stat.color}`}></i>
            </div>
            <p className="text-lg font-bold text-gray-900">
              {stat.value}
              <span className="text-xs font-normal text-gray-400 ml-0.5">{stat.suffix}</span>
            </p>
            <p className="text-xs text-gray-400 mt-0.5">{stat.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
